import { Component, OnInit } from '@angular/core';
import { IdeaGenStateService } from '../../idea-gen-state.service';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { ThemeTrendsComponent } from '../theme-trends/theme-trends.component';
import { TopThemesComponent } from '../top-themes/top-themes.component';
import { MainNavbarComponent } from '../../../../core/components/main-navbar/main-navbar.component';
import { ClusterTreemapComponent } from '../../../results/components/result-sections/clustering/cluster-treemap/cluster-treemap.component';
import { FormControl, FormsModule } from '@angular/forms';
import { REGION_CODES } from '../../../../../../public/country-region-codes';
import { Observable } from 'rxjs';
import { Options } from '@angular-slider/ngx-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { McapSliderComponent } from 'src/app/shared/components/mcap-slider/mcap-slider.component';
import { MatDialog } from '@angular/material/dialog';
import { McapDualSliderComponent } from 'src/app/shared/components/mcap-dual-slider/mcap-dual-slider.component';
import { UniverseSelectorComponent } from 'src/app/shared/components/universe-selector/universe-selector.component';


@Component({
  selector: 'app-idea-generation-home',
  standalone: true,
  imports: [CommonModule, SidebarComponent, ThemeTrendsComponent, TopThemesComponent, MainNavbarComponent, ClusterTreemapComponent, FormsModule, NgxSliderModule],
  templateUrl: './idea-generation-home.component.html',
  styleUrl: './idea-generation-home.component.css'
})
export class IdeaGenerationHomeComponent implements OnInit {
  selectedOption: string = '';
  qipHighlightsTheme: string = '';
  endDate: string = '';
  marketCap: string = 'all';
  searchType: string = 'themes';
  heading: string | null = null;
  roles: any;
  ngOnInit(): void {
    this.handleSubmit();
    this.roles = JSON.parse(localStorage.getItem('roles')!);
    // if(!this.roles.includes("alpha")){
    //   this.searchType="themes";
    // }
  }
  countriesControl = new FormControl<string[]>([]);
  expandedRegions: Set<string> = new Set();


  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
  countryFilterOptions = REGION_CODES;
  disableButtons$: Observable<boolean> = this.stateService.disableButtons$;
  constructor(private stateService: IdeaGenStateService, private dialog: MatDialog) {
    // Subscribe to changes in selected option and market
    this.stateService.selectedOption$.subscribe((option) => {
      this.selectedOption = option;
      if (option === 'topFlopThemes') {
        this.heading = null;
      }
    });
    this.stateService.selectedQipHighlight$.subscribe((theme) => {
      this.qipHighlightsTheme = theme
    })

    //subscribe to changes in disableButtons variable

    const today = new Date();
    this.endDate = today.toISOString().split('T')[0];
  }

  marketCapDisplay: string = 'All Market Cap';

  selectMarketCap(value: string) {
    this.marketCap = value;
    const displayMapping: { [key: string]: string } = {
      all: 'All Market Cap',
      large_cap: 'Large Cap (>$5B)',
      small_cap: 'Small Cap (<$5B)'
    };
    this.marketCapDisplay = displayMapping[value] || value;
  }
  openUniverseSelector() {
    const dialogRef = this.dialog.open(UniverseSelectorComponent, {
      data: {
        min_mcap: this.min_market_cap,
        max_mcap: this.max_market_cap,
        include_public: this.public_company,
        include_private: this.private_company,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      this.private_company = result.isPrivate;
      this.public_company = result.isPublic;
      this.max_market_cap = result.max;
      this.min_market_cap = result.min;
    });
  }
  getTechfieldHighlights(data: { query: string | null, entityids: [string] | null, name: string | null }) {
    this.marketCap = 'all';
    const displayMapping: { [key: string]: string } = {
      all: 'All Market Cap',
      large_cap: 'Large Cap (>$5B)',
      small_cap: 'Small Cap (<$5B)'
    };

    if (data.query == 'large_cap' || data.query == 'small_cap') {
      this.marketCap = 'large_cap';

      if (data.query == 'small_cap') {
        this.marketCap = 'small_cap';
      }
      data.query = null;
    }
    this.marketCapDisplay = displayMapping[this.marketCap] || this.marketCap;

    this.stateService.setQuery({
      market_cap: this.marketCap,
      countries: null,
      date_end: this.endDate,
      query: data.query,
      entityids: data.entityids,
      search_type: this.searchType,
      min_market_cap: this.min_market_cap,
      max_market_cap: this.max_market_cap,
      private_company: this.private_company,
      public_company: this.public_company
    });
    this.heading = data.name;
  }

  onSearchTypeChange(type: string) {
    this.searchType = type; // Update the search type

  }

  handleSubmit() {
    //disable all buttons to prevent unnecessary interactions 
    // this.stateService.setDisableButtons(true);
    this.stateService.setSelectedOption('topFlopThemes', 'all');
    this.heading = null;

    this.stateService.setQuery({
      market_cap: this.marketCap,
      countries: this.countriesControl.value,
      date_end: this.endDate,
      query: null,
      entityids: null,
      search_type: this.searchType,
      min_market_cap: this.min_market_cap,
      max_market_cap: this.max_market_cap,
      private_company: this.private_company,
      public_company: this.public_company
    });
  }


  toggleExpand(region: string): void {
    if (this.expandedRegions.has(region)) {
      this.expandedRegions.delete(region);
    } else {
      this.expandedRegions.add(region);
    }
  }

  isExpanded(region: string): boolean {
    return this.expandedRegions.has(region);
  }

  toggleRegionSelection(region: any): void {
    const allSelected = this.isRegionFullySelected(region);
    const regionCountryCodes = region.countries.map((c: any) => c.code);

    if (allSelected) {
      const updatedSelection = (this.countriesControl.value ?? []).filter(
        (value: string) => !regionCountryCodes.includes(value)
      );
      this.countriesControl.setValue(updatedSelection);
    } else {
      const updatedSelection = Array.from(
        new Set([...(this.countriesControl.value ?? []), ...regionCountryCodes])
      );
      this.countriesControl.setValue(updatedSelection);
    }
  }

  toggleCountrySelection(countryCode: string, region: any): void {
    const currentSelection = this.countriesControl.value ?? [];
    const isSelected = currentSelection.includes(countryCode);

    if (isSelected) {
      this.countriesControl.setValue(
        currentSelection.filter((value: string) => value !== countryCode)
      );
    } else {
      this.countriesControl.setValue([...currentSelection, countryCode]);
    }
  }

  isRegionFullySelected(region: any): boolean {
    const regionCountryCodes = region.countries.map((c: any) => c.code);
    const selectedCodes = this.countriesControl.value ?? [];
    return regionCountryCodes.every((code: string) => selectedCodes.includes(code));
  }
  min_market_cap = null;
  max_market_cap = null;
  private_company = true;
  public_company = true;

  openMcapDialog() {
    // console.log("Inside idea gen openMcapDIalog, min, max",this.min_market_cap,this.max_market_cap);
    const dialogRef = this.dialog.open(McapSliderComponent, { data: { min_market_cap: this.min_market_cap, max_market_cap: this.max_market_cap } });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.min_market_cap = result.min;
        this.max_market_cap = result.max;
        // console.log("RESULT",result);
      }
    });
  }


  formatMarketCap(value: number): string {
    if (!value) return '0';
    if (value >= 1e12) {
      const trillions = value / 1e12;
      return trillions % 1 === 0 ? trillions.toString() + 'T (USD)' : trillions.toFixed(2) + 'T (USD)';
    }
    if (value >= 1e9) {
      const billions = value / 1e9;
      return billions % 1 === 0 ? billions.toString() + 'B (USD)' : billions.toFixed(2) + 'B (USD)';
    }
    if (value >= 1e6) {
      const millions = value / 1e6;
      return millions % 1 === 0 ? millions.toString() + 'M (USD)' : millions.toFixed(2) + 'M (USD)';
    }
    return value.toString();
  }


  getPeerGroupSelectionText(): string {
    const selections: string[] = [];
    
    if (this.public_company) {
      selections.push('Public');
    }
    
    if (this.private_company) {
      selections.push('Private');
    }
    
    // Add market cap range if specified
    if (this.public_company && (this.min_market_cap || this.max_market_cap)) {
      const minText = this.min_market_cap ? this.formatMarketCap(this.min_market_cap) : '';
      const maxText = this.max_market_cap ? this.formatMarketCap(this.max_market_cap) : '';
      
      if (minText && maxText) {
        selections.push(`${minText}-${maxText}`);
      } else if (minText) {
        selections.push(`>${minText}`);
      } else if (maxText) {
        selections.push(`<${maxText}`);
      }
    }
    
    return selections.length > 0 ? selections.join(', ') : '';
  }

  hasPeerGroupSelection(): boolean {
    return this.public_company || this.private_company;
  }


  // openMcapDialog2() {
  //   const dialogRef = this.dialog.open(McapDualSliderComponent);

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.min_market_cap = result.min;
  //       this.max_market_cap = result.max;
  //       // console.log("2: ",result);
  //     }
  //   });
  // }
}
